import InputSearch from './components/InputSearch'
import OrderPartners from './components/OrderPartners'
import ResultPartner from './components/ResultPartner'
import TextSection from './components/TextSection'
import { PartnerSearchProvider } from './core/PartnerSearchProvider'
import { ContainerStyles } from './styles'
import type { PartnersListProps } from './types'

const PartnerSearchList = ({
  items,
  spaceIn,
  settingsLink,
  title,
  subtitle,
  cardButtonLabel,
  concatenation,
}: PartnersListProps) => (
  <PartnerSearchProvider
    title={title}
    subtitle={subtitle}
    concatenation={concatenation}
    cardButtonLabel={cardButtonLabel}
    items={items}
    settingsLink={settingsLink}
  >
    <ContainerStyles spaceIn={spaceIn}>
      <TextSection />
      <InputSearch />
      <OrderPartners />
      <ResultPartner />
    </ContainerStyles>
  </PartnerSearchProvider>
)
export default PartnerSearchList
